module.exports = __webpack_public_path__ + "img/jimber.d6a35d4a.png";